import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material';

const styles = makeStyles(() => ({
	Container: {
		marginTop: useTheme().spacing(2),
		marginBottom: useTheme().spacing(1),
	},
	boxContainer: {
		marginTop: useTheme().spacing(0.5),
		marginBottom: useTheme().spacing(1),
	},
	formContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px',
		padding: '0px',
		margin: '0px',
	},
	tableContainer: {
		width: '100%',
		display: 'table',
		tableLayout: 'fixed',
	},
	tableClass: {
		borderColor: 'initial',
		marginTop: '5px',
		marginBottom: '5px',
		borderRadius: '5px',
	},
	tableHeader: {
		padding: 8,
	},
	paper: {
		paddingTop: '0px',
		paddingBottom: '0px',
		paddingLeft: '0px',
		borderRadius: 10,
		backgroundColor: 'rgb(255, 255, 255)',
		boxShadow:
			'rgba(0, 0, 0, 0.06) 0px 3px 3px -2px, rgba(0, 0, 0, 0.04) 0px 3px 4px 0px, rgba(0, 0, 0, 0.04) 0px 1px 8px 0px !important',
	},
	headingLabel: {
		fontSize: '15px',
		width: '100%',
		display: 'inline-block',
	},
	formHeading: {
		fontSize: '16px',
		fontWeight: '500',
		marginBottom: '0px',
		marginLeft: '0px',
	},
	h2heading: { margin: '0px', padding: '15px', fontSize: '18px' },

	typography: {
		padding: '0px 20px 20px 20px',
		flexDirection: 'column',
		fontSize: '14px',
		margin: '0px',
		width: '100%',
	},
	gridContainer: {
		padding: '0px 20px 12px 20px',
		flexDirection: 'column',
		margin: '0px',
		width: '100%',
	},
	grid: {
		marginTop: useTheme().spacing(2),
	},
	innerGrid: {
		marginTop: '10px',
		backgroundColor: '#f3f3f3',
		padding: '10px 15px',
	},
	Financialyear: {
		marginTop: useTheme().spacing(3),
		flexDirection: 'row',
		display: 'flex',
	},
	FinancialLabel: {
		width: '100%',
		display: 'flex',
		alignItems: 'center',
		fontSize: '14px',
	},
	selectInput: {
		position: 'relative',
		fontSize: 14,
	},
	menuClass: {
		fontSize: 14,
	},
	boldLabel: {
		// fontWeight: 600,
		fontWeight: useTheme().typography.fontWeightBold,
		fontSize: '14px',
	},
	ContainerP: {
		// display: 'flex !important',
		justifyContent: 'space-between !important',
		alignItems: 'center ',
	},
	paymentFrequency: {
		// display: 'flex !important',
		justifyContent: 'space-between !important',
		alignItems: 'center ',
		fontSize: '14px',
	},
	ContainerPDiv: {
		display: 'block',
		fontSize: '14px',
	},
	ContainerPay: {
		display: 'flex !important',
		justifyContent: 'space-between !important',
		marginRight: useTheme().spacing(3),
	},

	ContainerPayDiv: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'nowrap',
	},
	textField: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'baseline',
		width: '100%',
	},
	textInputContainer: {
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		width: '100%',
	},
	dollarIconContainer: {
		position: 'absolute',
		right: '5px',
		top: '20px',
		bottom: 0,
		display: 'flex',
	},

	radioButtonContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: '10px',
	},
	textFieldLabel: {
		width: '100%',
		fontWeight: 'bold',
	},
	button: {
		marginTop: useTheme().spacing(1.5),
		float: 'left',
		fontSize: '14px',
		width: 115,
	},
	fieldContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: '10px',
		// margin: useTheme().spacing(1),
		// justifyContent: 'space-between',
	},
	Financial: {
		width: '100%',
	},
	labelContainer: {
		marginRight: '60px',
	},
	checkBoxLabel: {
		fontSize: '14px !important',
		margin: '0px',
	},
	textInput: {
		fontSize: '14px !important',
		width: '100%',
	},
	innerContainer: {
		display: 'flex',
		gap: 10,
	},
	customButtonClass: {
		width: 110,
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 4,
	},
	[useTheme().breakpoints.down('md')]: {
		radioButtonContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
	},
	[useTheme().breakpoints.down('sm')]: {
		button: {
			marginTop: useTheme().spacing(3),
			width: '100%',
		},
		innerContainer: {
			flexDirection: 'column',
		},
		Financial: {
			width: '100%',
		},
		ContainerPayDiv: {
			flexDirection: 'column',
		},
		ContainerP: {
			flexDirection: 'column',
			alignItems: 'flex-start',
		},
		Financialyear: {
			flexDirection: 'column',
		},
		fieldContainer: {
			flexDirection: 'column',
		},
		textInput: {
			width: '100%',
		},
	},
	amount: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-around',
		paddingTop: useTheme().spacing(4),
		paddingBottom: useTheme().spacing(4),
		marginLeft: useTheme().spacing(2),
		marginRight: useTheme().spacing(2),
	},
}));

export default styles;
